export enum DossierExportStatus {
    Queued = "Queued",
    Running = "Running",
    Completed = "Completed",
    Failed = "Failed",
}
